import { Allotment } from 'allotment'
import { ReactNode } from 'react'

import 'allotment/dist/style.css'

export function SplitLayout({ firstContent, secondContent }: { firstContent?: ReactNode; secondContent?: ReactNode }) {
  return (
    <Allotment className="isolate [--focus-border:theme(colors.blue.500)] [--separator-border:theme(colors.zinc.950/10%)] dark:[--separator-border:theme(colors.white/10%)]">
      <Allotment.Pane minSize={320}>{firstContent}</Allotment.Pane>
      <Allotment.Pane>{secondContent}</Allotment.Pane>
    </Allotment>
  )
}
